import axios from 'axios';
import { useFormik } from 'formik';
import React, { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup'
import { paths } from '../../utils/routes';
import toast from 'react-hot-toast';
 import { Helmet } from 'react-helmet'


export default function ResetPassword() {
    <Helmet>
        <meta charSet="utf-8" />
        <title>Reset Password</title>
    </Helmet>
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState('');
    const navigator = useNavigate()
    const initialValues = {
        email: '',
    }

    const verifyResetCode = async (data) => {
        try {
            setIsLoading(true)
            const resetCode = localStorage.getItem('resetCode');
            const response = await axios.post("https://ecommerce.routemisr.com/api/v1/auth/verifyResetCode", { resetCode })

            resetPassowrd(data)
            setIsLoading(false)

        } catch (error) {
            setError(error.response.data.message)
            setIsLoading(false)

        }
    }

    const resetPassowrd = async (data) => {
        try {
            setIsLoading(true)
            const response = await axios.put("https://ecommerce.routemisr.com/api/v1/auth/resetPassword", { ...data })
            toast.success('Password has been Reset!')
            navigator(`${paths.login}`)
            setIsLoading(false)

        } catch (error) {
            setError(error.response.data.message)
            setIsLoading(false)
        }
    }


    const validationSchema = Yup.object({
        email: Yup.string().email('Email is Invalid').required('Email is Required'),
        newPassword: Yup.string().required('Password is Required').min(8, 'Password must be more than 8 Chars').max(16, 'You Reached Maximum length'),

    })
    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: resetPassowrd
    })
    return <>
        <div className="w-75 m-auto p-3">
            <h3 className='my-3'>Reset Password</h3>
            {error && <p className='alert alert-danger'>{error}</p>}
            <form onSubmit={formik.handleSubmit}>
                <label htmlFor="email">Email</label>
                <input type="email" name="email" id="email" className='form-control my-2' onChange={formik.handleChange} onBlur={formik.handleBlur} />
                {formik.errors.email && formik.touched.email && <p className='alert alert-danger'> {formik.errors.email}</p>}
                <label htmlFor="newPassword">New Password</label>
                <input type="password" name="newPassword" id="newPassword" className='form-control my-2' onChange={formik.handleChange} onBlur={formik.handleBlur} />
                {formik.errors.newPassword && formik.touched.newPassword && <p className='alert alert-danger'> {formik.errors.newPassword}</p>}

                <button type='submit' className='bg-main btn text-white mt-2' disabled={!(formik.errors && formik.dirty)}>{isLoading ? <i className="fa-solid fa-spinner fa-spin"></i> : 'Reset'}</button>
            </form>
        </div>
    </>
}
